import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";

const PrevFirstTimeRidesMonthToDate = () => {
  const { prevFirstTimeRidesMTD, prevFirstTimeRidesMTDRawDataLink } = useSelector(
    (state) => state.firstRiders.firstTimeRiders?.firstTimeRides
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <NumberDisplay
      value={prevFirstTimeRidesMTD}
      url={prevFirstTimeRidesMTDRawDataLink}
      disableAnimation={isUserQa}
    />
  );
};

export default PrevFirstTimeRidesMonthToDate;
